import { Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import type { IProjectMemberSourceTeam } from '../../api/types/projects'
import { routesProfile } from '../../consts'

type Props = {
  team: IProjectMemberSourceTeam
}

const labelSx = {
  fontSize: 10,
  lineHeight: '14px',
  color: 'text.secondary',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
} as const

export const TeamSourceLabel = ({ team }: Props) => (
  <Typography
    variant="black-12-light"
    component={RouterLink}
    to={`/${routesProfile.TEAMS.path}/${team.slug || team.id}`}
    sx={labelSx}
    onClick={(event) => event.stopPropagation()}
  >
    из команды «{team.name}»
  </Typography>
)
